module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_01-2761c04393303c9cb7ec231dd5d4c1d3.png";